import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import cn from 'classnames';

import { useDispatch, useSelector } from 'store';
import { fetchCompanies, setActiveCompany } from 'store/companiesReducer';
import { fetchProfileData, selectIsAuth } from 'store/usersReducer';
import { fetchBalanceData } from 'store/balanceReducer';
import YM from 'utils/metrics';
import Header from 'pages/Layout/Header';
import classes from './layout.module.scss';

const Layout: React.FC = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const { companyId = '' } = useParams();
	const isAuth = useSelector(selectIsAuth);

	const getUserData = async (): Promise<void> => {
		try {
			const { user } = await dispatch(fetchProfileData()).unwrap();
			YM.onLogin(user.id);
			dispatch(fetchBalanceData());
			const companies = await dispatch(fetchCompanies()).unwrap();
			const activeCompanyId = companyId || companies[0].id || '';
			const activeCompany =
				companies.find(
					(company) => `${company.id}` === `${activeCompanyId}`
				) || null;
			dispatch(setActiveCompany(activeCompany));
			if (location.pathname === '/') {
				const navigateUrl =
					companies.length > 1 || !activeCompanyId
						? '/companies'
						: `${activeCompanyId}/products`;
				navigate(navigateUrl);
			}
		} catch (err) {
			console.log(err);
			navigate('/companies');
		}
	};

	useEffect(() => {
		if (isAuth) {
			getUserData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isAuth]);

	return (
		<div
			className={cn(classes.layout, { [classes.layout__auth]: !isAuth })}
		>
			{isAuth && <Header />}
			<Outlet />
		</div>
	);
};

export default Layout;
